// Sweeth's policies as a stopgap — swap for the final witMetrics documents.
export const TERMS_URL = 'https://sweeth.pro/terms-conditions';

export const PRIVACY_URL = 'https://sweeth.pro/privacy-policy';
